import React from "react";
import "../styles/Partners.css";
import logopetroge from "../assets/logo-pet.png";
import logoupi from "../assets/logo-upi.png";

const partnersData = [
  {
    name: "Petroge Energy",
    location: "Tbilisi, Georgia",
    logo: logopetroge,
  },
  {
    name: "UPI GROUP",
    location: "Singapore",
    logo: logoupi,
  },
];

export default function AboutPartners() {
  return (
    <section className="partners-section">
      {/* <div className="container"> */}
        <h2 className="section-title">Our Partners</h2>

        <div className="partners-list">
  {partnersData.map((partner, idx) => (
    <div
      key={idx}
      className={`partner-card ${idx === 0 ? "petroge" : ""}`}
    >
      
      {/* Column 1: Logo */}
      <div className="partner-logo">
        <img src={partner.logo} alt={partner.name} />
      </div>

      {/* Column 2: Details */}
      <div className="partner-details">
        <h3>{partner.name}</h3>
        <p>{partner.location}</p>
      </div>

    </div>
  ))}
</div>

      {/* </div> */}
    </section>
  );
}
